import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurysedanrentals() {



  const cardData =
  {
    keyword: 'Luxury Sedan Rentals with Drivers in Pune',
    heading: 'Aaryan Travels: Luxury Sedan Rentals with Drivers in Pune',
    headingDescription: ' Aaryan Travels offers premium Luxury Sedan Rentals with Drivers in Pune for professionals, VIP guests, and travelers who value comfort and sophistication. Whether it’s an airport transfer from Pune International Airport, a corporate meeting in Kalyani Nagar, or a special occasion ride to Mahabaleshwar or Lonavala, our fleet of luxury sedans—including Honda City, Mercedes, BMW, and Skoda—ensures a smooth and elegant journey. With uniformed chauffeurs, plush interiors, and on-request amenities like Wi-Fi and bottled water, Aaryan Travels delivers a first-class travel experience across Koregaon Park, Hinjewadi, Baner, and Magarpatta. For stylish and reliable chauffeur-driven sedans, we are your trusted partner in Pune.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most renowned fort palace and a proud symbol of Maratha history. Once the seat of Bajirao I and the Peshwa dynasty, it features massive gateways such as the Delhi Darwaza, sprawling courtyards, and grand architecture. Though partially destroyed by fire in 1828, its walls still echo tales of valor. The evening light-and-sound show beautifully narrates Maratha glory. Shaniwar Wada remains Pune’s iconic historical landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, holds great importance in India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India movement. Today, it serves as a museum preserving their belongings and photographs. Its lush gardens and Italian arches add to its beauty. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s serene memorial of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees every day. During Ganesh Chaturthi, the temple becomes the center of grand celebrations. Its spiritual aura brings peace and strength to all visitors. Dagdusheth Ganpati is Pune’s sacred heart of devotion."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located atop a hill, is known for the Battle of 1670 where Tanaji Malusare heroically fought for Shivaji Maharaj. Trekkers enjoy the scenic climb to the top, rewarded by breathtaking views of the Sahyadris. Local villagers serve traditional pithla-bhakri near the summit. The fort’s atmosphere reflects valor and courage. Sinhagad is Pune’s perfect blend of history, trekking, and nature."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill offers a panoramic view of Pune after climbing 103 steps to the hilltop temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa era, it features smaller shrines and a museum. Sunrise and sunset from the hill are breathtaking. It is a favorite spot for peaceful reflection. Parvati Hill is Pune’s spiritual viewpoint in the sky."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt stone. Its giant pillars and circular Nandi pavilion showcase ancient Indian craftsmanship. Despite being in the city center, it offers a calm and spiritual retreat. Evening chants add serenity. Pataleshwar is Pune’s hidden cave of devotion."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. From musical instruments and ornaments to sculptures and everyday antiques, the collection showcases India’s cultural diversity. The reconstructed Mastani Mahal draws special interest. It is a delight for history enthusiasts. The museum is Pune’s treasure house of traditions."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort offers peaceful surroundings for self-discovery and healing. Spread across beautifully landscaped gardens, it provides meditation sessions, therapy programs, and retreats. Visitors from around the world come here seeking inner peace. Osho Ashram is Pune’s global sanctuary of mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features bridges, flowing streams, and serene walkways. Seasonal flowers and lush greenery make it ideal for family outings and photography. The tranquil ambiance soothes the mind. The garden is Pune’s picturesque escape into nature."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a favorite picnic spot near Pune. The scenic lake surrounded by hills becomes especially beautiful during the monsoon. Visitors enjoy roasted corn and tea from nearby stalls. It is also the route to Sinhagad Fort. Khadakwasla is Pune’s relaxing waterside retreat."
  }
],


 "services": [
  {
    "name": "Luxury Sedan Rentals with Drivers in Pune",
    "description": "Luxury Sedan Rentals with Drivers in Pune provide an elegant and comfortable travel experience for business, leisure, and special events. Offering a wide range of premium sedans such as Mercedes, BMW, and Audi, each vehicle is equipped with plush interiors, climate control, and advanced safety features. Professionally trained chauffeurs ensure punctuality, discretion, and courteous service, making this an ideal choice for corporate meetings, airport transfers, and weddings. Clients can choose from hourly, daily, or monthly rental options, all managed with seamless booking and 24/7 support to guarantee a flawless travel experience."
  },
  {
    "name": "Chauffeur Driven Luxury Sedan Pune",
    "description": "Chauffeur Driven Luxury Sedan Pune offers an elevated travel solution featuring professional chauffeurs and high-end sedans. Each driver is experienced in corporate etiquette and city navigation, ensuring clients enjoy a smooth, relaxing, and luxurious journey. Perfect for business executives, events, or VIP guests, the service focuses on comfort, safety, and reliability."
  },
  {
    "name": "Premium Sedan Hire Pune",
    "description": "Premium Sedan Hire Pune provides luxury cars for discerning travelers seeking both style and comfort. With a selection of world-class sedans equipped with luxury interiors, leather seating, and top-notch amenities, this service is ideal for airport transfers, meetings, and special occasions requiring an elegant touch."
  },
  {
    "name": "Executive Car Rental Pune",
    "description": "Executive Car Rental Pune caters to professionals and corporates in need of high-quality transport. The fleet includes modern sedans designed for comfort and sophistication, ensuring smooth commutes and business travel. Flexible rental plans and chauffeur services make it a top choice for executives on the move."
  },
  {
    "name": "Luxury Car with Driver Pune",
    "description": "Luxury Car with Driver Pune provides the perfect combination of elegance and convenience. Clients can hire high-end sedans complete with courteous drivers trained in hospitality and local routes. Whether for client meetings, personal trips, or leisure travel, this service guarantees a premium experience every time."
  },
  {
    "name": "Best Luxury Sedan Pune",
    "description": "Best Luxury Sedan Pune is known for offering the finest collection of luxury sedans maintained to the highest standards. Ideal for weddings, events, and corporate occasions, each car ensures superior comfort, seamless performance, and impeccable presentation that elevates any travel experience."
  },
  {
    "name": "Affordable Luxury Sedan Hire Pune",
    "description": "Affordable Luxury Sedan Hire Pune makes premium travel accessible by offering high-quality sedans at competitive rates. Designed for clients who want luxury without overspending, this service ensures reliable chauffeurs, comfortable rides, and transparent pricing for both short and long-term needs."
  },
  {
    "name": "Corporate Luxury Sedan Pune",
    "description": "Corporate Luxury Sedan Pune specializes in business-class transportation with elegant sedans and trained chauffeurs. It’s tailored for company executives, clients, and visiting professionals who require punctuality, comfort, and discretion in every journey."
  },
  {
    "name": "Wedding Luxury Sedan Pune",
    "description": "Wedding Luxury Sedan Pune offers beautifully decorated sedans for bridal entries and guest transport during wedding ceremonies. The service focuses on elegance, comfort, and on-time coordination, ensuring that every moment of your special day runs smoothly."
  },
  {
    "name": "Premium Chauffeur Service Pune",
    "description": "Premium Chauffeur Service Pune delivers top-quality chauffeur experiences with a strong emphasis on professionalism, reliability, and hospitality. All drivers are background-verified, trained, and equipped to serve business and luxury clients with utmost care and punctuality."
  },
  {
    "name": "Online Luxury Sedan Booking Pune",
    "description": "Online Luxury Sedan Booking Pune allows customers to reserve luxury sedans quickly and efficiently through an easy digital platform. With instant confirmations, ride tracking, and support, it simplifies the process of booking high-end cars for any occasion."
  },
  {
    "name": "Luxury Car Hire Pune",
    "description": "Luxury Car Hire Pune offers a diverse selection of premium vehicles, from sedans to SUVs, suited for corporate travel, leisure, and events. With flexible rental durations, professional chauffeurs, and an emphasis on comfort, it’s Pune’s go-to service for elite transportation."
  },
  {
    "name": "Luxury SUV & Sedan Pune",
    "description": "Luxury SUV & Sedan Pune provides a balanced mix of spacious SUVs and sleek sedans to meet varied travel needs. Whether it’s for business meetings, family trips, or event logistics, clients enjoy safety, comfort, and style in every ride."
  },
  {
    "name": "Corporate Premium Sedan Pune",
    "description": "Corporate Premium Sedan Pune delivers executive-class sedans for companies seeking reliable and classy employee or client transport. Each car is maintained to perfection, ensuring a smooth ride that reflects corporate excellence and professionalism."
  },
  {
    "name": "Luxury Transport Pune",
    "description": "Luxury Transport Pune encompasses a complete suite of high-end mobility services, from luxury sedans to SUVs, tailored for personal, corporate, and event-based needs. With refined vehicles, skilled chauffeurs, and attention to every detail, it ensures every ride exceeds expectations."
  }
],
"tableData": [
  ["Luxury Sedan Rentals with Drivers in Pune", "Chauffeur Driven Luxury Sedan Pune"],
  ["Premium Sedan Hire Pune", "Executive Car Rental Pune"],
  ["Luxury Car with Driver Pune", "Best Luxury Sedan Pune"],
  ["Affordable Luxury Sedan Hire Pune", "Corporate Luxury Sedan Pune"],
  ["Wedding Luxury Sedan Pune", "Premium Chauffeur Service Pune"],
  ["Online Luxury Sedan Booking Pune", "Luxury Car Hire Pune"],
  ["Luxury SUV & Sedan Pune", "Corporate Premium Sedan Pune"],
  ["Luxury Transport Pune", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Luxury Sedan Rentals with Drivers in Pune",
    "WhyChoosedescription": "Aaryan Travels offers premium luxury sedan rentals with professional drivers in Pune, perfect for business and special occasions."
  },
  {
    "WhyChooseheading": "Fleet of Well-Maintained Luxury Sedans",
    "WhyChoosedescription": "Choose from a range of top-tier luxury sedans that provide comfort, style, and performance."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Chauffeurs",
    "WhyChoosedescription": "Our professional drivers ensure punctual, safe, and discreet service to enhance your travel experience."
  },
  {
    "WhyChooseheading": "Sanitized and Comfortable Vehicles",
    "WhyChoosedescription": "All sedans are regularly cleaned and maintained to guarantee hygiene and passenger comfort."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront pricing inclusive of fuel, tolls, and driver allowances without any surprise fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Customize your luxury sedan rental with driver based on hourly, daily, or long-term options."
  },
  {
    "WhyChooseheading": "Reliable and Timely Service Across Pune",
    "WhyChoosedescription": "We ensure prompt pickups and drop-offs for a seamless and luxurious travel experience."
  }
]




























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer luxury sedan rentals with drivers in Pune?',
    answer: 'Yes, Aaryan Travels provides premium luxury sedan rentals with professional drivers in Pune for a smooth and stylish ride.',
  },
  {
    question: 'How can I book luxury sedan rentals with drivers in Pune?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Pune.',
  },
  {
    question: 'What types of luxury sedans are available for rental with drivers in Pune?',
    answer: 'Aaryan Travels offers a range of luxury sedans including Mercedes-Benz, BMW, Audi, and other high-end models with drivers.',
  },
  {
    question: 'Are the drivers trained and experienced for luxury sedan rentals in Pune?',
    answer: 'Absolutely. Our drivers are professionally trained, punctual, and committed to delivering a premium travel experience.',
  },
  {
    question: 'Can luxury sedan rentals with drivers be booked for both business and personal use in Pune?',
    answer: 'Yes, these rentals are perfect for corporate meetings, airport transfers, weddings, and personal trips in and around Pune.',
  },
  {
    question: 'Is the luxury sedan rental service with drivers available 24x7 in Pune?',
    answer: 'Yes, Aaryan Travels offers round-the-clock luxury sedan rental services with drivers to suit your schedule in Pune.',
  },
  {
    question: 'Are hygiene and safety protocols followed for luxury sedan rentals?',
    answer: 'All vehicles are thoroughly sanitized, and drivers follow strict safety and hygiene guidelines for your peace of mind.',
  },
  {
    question: 'What payment options are accepted for luxury sedan rentals with drivers in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the luxury sedan rental period in Pune?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your rental experience in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Shantanu Desai',
    feedback: 'Aaryan Travels provided excellent luxury sedan rentals with a courteous driver in Pune. Truly premium service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rucha Mehta',
    feedback: 'Highly recommend Aaryan Travels for luxury sedan rentals in Pune. The car was spotless and the ride very smooth.',
    rating: 5,
  },
];

















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Sedan Rentals with Drivers in Pune",
  "image": "https://aaryantravels.com/assets/images/luxury-sedan-rentals-with-drivers-in-pune.jpg", // replace with actual image URL
  "description": "Aaryan Travels offers premium luxury sedan rentals with drivers in Pune. Experience executive comfort, professional chauffeurs, and flexible booking options for business, weddings, and personal travel.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // example rating
    "ratingCount": "2700", // example rating count
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",  // example starting price
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/luxury-sedan-rentals-with-drivers-in-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>Luxury Sedan Rentals with Drivers in Pune | Premium Chauffeur Cars | Aaryan Travels</title>
  <meta
    name="description"
    content="Aaryan Travels offers premium luxury sedan rentals with drivers in Pune. Enjoy executive-level comfort, professional chauffeurs, and flexible packages for corporate, wedding, and personal travel."
  />
  <meta
    name="keywords"
    content="Luxury Sedan Rentals with Drivers in Pune, Chauffeur Driven Luxury Sedan Pune, Premium Sedan Hire Pune, Executive Car Rental Pune, Luxury Car with Driver Pune, Best Luxury Sedan Pune, Affordable Luxury Sedan Hire Pune, Corporate Luxury Sedan Pune, Wedding Luxury Sedan Pune, Premium Chauffeur Service Pune, Online Luxury Sedan Booking Pune, Luxury Car Hire Pune, Luxury SUV & Sedan Pune, Corporate Premium Sedan Pune, Luxury Transport Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/40.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurysedanrentals;